// Mock data for Purrflect (cat-care app). All data here is MOCKED for the
// frontend-only teaser. Backend + Stripe will replace these later.

export const BRAND = {
  name: 'Purrflect',
  tagline_top: "Your cat's",
  tagline_rest: 'wellbeing, in your pocket.',
  subtitle:
    'Ask our AI vet anything, upload symptom photos, and find trusted local cat vets \u2014 all in one warm, friendly app.',
  heroImage:
    'https://images.unsplash.com/photo-1561948955-570b270e7c36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
};

// Sister app (the dog version). Used for the bundle cross-promo + link.
export const PAWPAL_URL = 'https://wooflect.happybigdogs.net';

// Pet-parent subscription. Single-app price matches Dog Care Connect 2 ($9).
// Bundle = both apps (dog + cat) for $14/mo.
export const PARENT_PLAN = {
  price: 9,
  bundlePrice: 14,
  perks: [
    'Unlimited AI vet chats',
    'Symptom photo analysis',
    'Priority answers, day or night',
    'Full cat health history & reminders',
  ],
};

export const VET_PLANS = [
  {
    id: 'basic',
    name: 'Basic Featured',
    price: 49,
    bundlePrice: 79,
    best: false,
    perks: ['Featured placement', 'Featured badge', 'Brand-tinted card', 'One-tap Call & Directions'],
  },
  {
    id: 'premium',
    name: 'Premium Featured',
    price: 149,
    bundlePrice: 199,
    best: true,
    perks: ['Everything in Basic', 'Top billing in emergency filter', 'Priority support', 'Monthly insights'],
  },
];

export const VET_BENEFITS = [
  { icon: 'TrendingUp', title: 'Grow your client base', desc: 'Featured placement puts your clinic in front of cat parents actively searching for care.' },
  { icon: 'Star', title: 'Featured badge', desc: 'Stand out with a Featured badge and brand-tinted card in every search result.' },
  { icon: 'TriangleAlert', title: 'Emergency priority', desc: 'Premium tier gets top billing in the emergency filter \u2014 where every minute matters.' },
  { icon: 'Phone', title: 'Direct inbound calls', desc: 'One-tap Call and Directions actions on your listing drive real leads to your clinic.' },
];

export const CAT_AVATARS = [
  'https://images.unsplash.com/photo-1536589961747-e239b2abbec2?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
  'https://images.unsplash.com/photo-1498100152307-ce63fd6c5424?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
  'https://images.unsplash.com/photo-1507568237455-03228e5ddb7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
  'https://images.unsplash.com/photo-1542736705-53f0131d1e98?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
  'https://images.unsplash.com/photo-1615789591457-74a63395c990?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
];

export const BREEDS = ['Domestic Shorthair', 'Maine Coon', 'Siamese', 'Persian', 'Bengal', 'Ragdoll', 'British Shorthair', 'Tabby', 'Tuxedo', 'Sphynx'];

// Beta launch markets (must match backend BETA_CODES cities)
export const METROS = ['Portland, OR', 'Eugene/Springfield, OR', 'San Francisco, CA', 'Other'];

export const AI_SUGGESTIONS = [
  'My cat is not eating today',
  'Is chocolate dangerous for cats?',
  'How often should I deworm my kitten?',
  'My cat is sneezing a lot',
  'Best food for a senior cat?',
];

// Very light keyword-based mock AI. Real LLM comes in the backend phase.
export function mockAiReply(text) {
  const t = (text || '').toLowerCase();
  const disc = '\n\nThis is general guidance, not a diagnosis. If symptoms persist or worsen, please see a vet.';
  if (t.includes('not eating') || t.includes('appetite'))
    return "A cat skipping one meal can be normal, but going 24h+ without eating is a red flag for cats and can lead to fatty liver disease. Try warming their food, offering a strong-smelling wet food, and ensure fresh water. If they refuse food for more than a day, or seem lethargic, book a vet visit." + disc;
  if (t.includes('chocolate') || t.includes('poison') || t.includes('toxic'))
    return "Yes \u2014 chocolate, lilies, onions, garlic, and grapes are all toxic to cats. Lilies are especially dangerous and can cause kidney failure even in tiny amounts. If you suspect ingestion, treat it as an emergency and call a vet right away." + disc;
  if (t.includes('sneez') || t.includes('cold') || t.includes('runny'))
    return "Occasional sneezing is usually harmless. Frequent sneezing with runny eyes/nose can point to a feline upper respiratory infection. Keep them warm, hydrated, and watch for reduced appetite. If it lasts more than a few days, a vet can help." + disc;
  if (t.includes('deworm') || t.includes('worm') || t.includes('kitten'))
    return "Kittens are usually dewormed every 2 weeks from 3\u20139 weeks of age, then monthly until 6 months. Adult indoor cats typically need it 2\u20134 times a year. Your vet can tailor a schedule based on lifestyle." + disc;
  if (t.includes('senior') || t.includes('old') || t.includes('food'))
    return "Senior cats (7+) do best on easily-digestible, high-quality protein with controlled phosphorus to protect kidneys. Wet food helps hydration. Watch weight closely and consider twice-yearly checkups." + disc;
  return "Thanks for sharing that. Can you tell me a bit more \u2014 how long has this been going on, and have you noticed changes in eating, drinking, litter box use, or energy? Meanwhile, keep your cat calm, hydrated and comfortable." + disc;
}

export const SYMPTOM_RESULT = {
  title: 'Possible skin irritation',
  confidence: 'Moderate',
  causes: ['Flea allergy dermatitis', 'Mild contact irritation', 'Over-grooming from stress'],
  advice: 'Keep the area clean and dry, prevent scratching, and check for fleas. If it spreads, weeps, or your cat seems in pain, see a vet within 24\u201348 hours.',
};

export const CLINICS = [
  { id: 'c1', name: 'Whiskers & Co. Cat Clinic', tier: 'premium', rating: 4.9, reviews: 412, distance: '0.8 mi', emergency: true, address: '210 Maple Ave, Downtown', phone: '+1-555-0142', hours: 'Open \u00b7 24/7 Emergency', img: 'https://images.unsplash.com/photo-1583795128727-6ec3642408f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=400' },
  { id: 'c2', name: 'Feline Health Center', tier: 'premium', rating: 4.8, reviews: 288, distance: '1.4 mi', emergency: true, address: '55 Birch Street', phone: '+1-555-0187', hours: 'Open until 9 PM', img: 'https://images.unsplash.com/photo-1615789591457-74a63395c990?crop=entropy&cs=srgb&fm=jpg&q=85&w=400' },
  { id: 'c3', name: 'Sunnyside Veterinary', tier: 'basic', rating: 4.7, reviews: 156, distance: '2.1 mi', emergency: false, address: '9 Garden Lane', phone: '+1-555-0110', hours: 'Open until 6 PM', img: 'https://images.unsplash.com/photo-1507568237455-03228e5ddb7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=400' },
  { id: 'c4', name: 'Riverside Animal Care', tier: 'basic', rating: 4.6, reviews: 98, distance: '2.6 mi', emergency: true, address: '1200 River Rd', phone: '+1-555-0165', hours: 'Open until 8 PM' },
  { id: 'c5', name: 'Oak Street Pet Hospital', tier: 'none', rating: 4.4, reviews: 61, distance: '3.0 mi', emergency: false, address: '77 Oak Street', phone: '+1-555-0133', hours: 'Closed \u00b7 Opens 8 AM' },
  { id: 'c6', name: 'Meadow Vets', tier: 'none', rating: 4.3, reviews: 44, distance: '3.8 mi', emergency: false, address: '14 Meadow Close', phone: '+1-555-0199', hours: 'Open until 5 PM' },
];
